var requireObjectCoercible = require('../internals/require-object-coercible');

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/to-object.js